import api from '../utils/api';
import config from '../config';

export interface SearchItem {
  id: string;
  name: string;
  type: 'file' | 'folder';
  mimetype?: string;
  mimeType?: string;
  size?: number;
  parentId?: string | null;
  createdAt?: string;
  updatedAt?: string;
  contentMatch?: boolean;
  contentSnippet?: string;
  [key: string]: unknown;
}

export interface SearchPagination {
  total: number;
  page: number;
  limit: number;
  pages: number;
}

export interface SearchResult {
  items: SearchItem[];
  pagination: SearchPagination;
}

export interface SearchParams {
  term: string;
  type?: 'file' | 'folder';
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
  includeContent?: boolean;
  parentId?: string;
}

const searchService = {
  async search(params: SearchParams): Promise<SearchResult> {
    const response = await api.get(config.api.search, {
      params: {
        term: params.term,
        type: params.type,
        page: params.page ?? 1,
        limit: params.limit ?? 50,
        sortBy: params.sortBy,
        sortOrder: params.sortOrder,
        includeContent: params.includeContent,
        parentId: params.parentId
      }
    });
    return {
      items: response.data?.items || [],
      pagination: response.data?.pagination || {
        total: 0,
        page: 1,
        limit: 50,
        pages: 0
      }
    };
  },

  async quickSearch(term: string, limit = 8): Promise<SearchItem[]> {
    const response = await api.get(`${config.api.search}/quick`, {
      params: { term, limit }
    });
    return response.data?.items || [];
  }
};

export default searchService;
